/* ==========================================================================
   OTX — Carrusel de vídeos verticales.

   Reglas de la casa:
   - Suena solo lo que el cliente pide. Los vídeos arrancan mudos.
   - Se reproduce UNO cada vez: el que está centrado (o el que tiene el ratón
     encima). Con cuatro tarjetas a la vista, reproducirlas todas serían 20 MB
     de descarga por visita y un móvil ardiendo.
   - Un clic pone sonido y calla a los demás.
   - Si el navegador prohíbe el autoplay (iOS en bajo consumo, ahorro de
     datos), la tarjeta se queda en su portada con el aviso "toca para
     reproducir": nunca un cuadro negro.
   ========================================================================== */

(function () {
  'use strict';

  var TXT_REPRODUCIR = 'Toca para reproducir';
  var TXT_SONIDO = 'Toca para oírlo';
  var HUECO = 16;

  var sinMovimiento =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciar(raiz) {
    if (raiz.dataset.otxIniciado === '1') return;
    raiz.dataset.otxIniciado = '1';

    var pista = raiz.querySelector('[data-otx-videos-pista]');
    var tarjetas = Array.prototype.slice.call(raiz.querySelectorAll('[data-otx-video-card]'));
    var puntos = Array.prototype.slice.call(raiz.querySelectorAll('[data-otx-punto]'));
    var prev = raiz.querySelector('[data-otx-flecha="prev"]');
    var next = raiz.querySelector('[data-otx-flecha="next"]');
    var autoplay = raiz.dataset.autoplay !== 'false' && !sinMovimiento;

    if (!pista || !tarjetas.length) return;

    var aVista = tarjetas.map(function () {
      return false;
    });
    var conRaton = tarjetas.map(function () {
      return false;
    });

    /* ---------- Estado de cada tarjeta ---------- */

    function video(tarjeta) {
      return tarjeta.querySelector('video');
    }

    function suena(v) {
      return v && !v.muted && !v.paused;
    }

    function pintar(tarjeta) {
      var v = video(tarjeta);
      if (!v) return;

      tarjeta.dataset.sonido = suena(v) ? 'on' : 'off';

      var aviso = tarjeta.querySelector('[data-otx-aviso]');
      var texto = v.paused ? TXT_REPRODUCIR : TXT_SONIDO;
      if (aviso && aviso.textContent !== texto) aviso.textContent = texto;

      var boton = tarjeta.querySelector('[data-otx-toque]');
      if (boton) {
        var nombre = boton.dataset.nombre || 'este vídeo';
        boton.setAttribute(
          'aria-label',
          v.paused
            ? 'Reproducir ' + nombre
            : suena(v)
              ? 'Silenciar ' + nombre
              : 'Escuchar ' + nombre + ' con sonido'
        );
      }
    }

    function reproducir(tarjeta, mudo) {
      var v = video(tarjeta);
      if (!v) return;
      v.muted = mudo;
      var p = v.play();
      if (p && typeof p.catch === 'function') {
        p.then(function () {
          pintar(tarjeta);
        }).catch(function () {
          // El navegador ha dicho que no. Si era con sonido, lo intentamos
          // mudo: peor eso que dejar la tarjeta parada tras un clic.
          v.muted = true;
          if (!mudo) {
            var p2 = v.play();
            if (p2 && typeof p2.then === 'function') {
              p2.then(
                function () {
                  pintar(tarjeta);
                },
                function () {
                  pintar(tarjeta);
                }
              );
            }
          }
          pintar(tarjeta);
        });
      } else {
        pintar(tarjeta);
      }
    }

    function parar(tarjeta) {
      var v = video(tarjeta);
      if (!v || v.paused) return;
      v.pause();
      v.muted = true;
      pintar(tarjeta);
    }

    /* ---------- Quién suena y quién no ---------- */

    function indiceCentrado() {
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var mejor = 0;
      var mejorDist = Infinity;
      tarjetas.forEach(function (tarjeta, i) {
        var c = tarjeta.offsetLeft + tarjeta.offsetWidth / 2;
        var d = Math.abs(c - centro);
        if (d < mejorDist) {
          mejorDist = d;
          mejor = i;
        }
      });
      return mejor;
    }

    // La visibilidad se mide por geometría y no solo con el observador:
    // el observador no dispara si la pestaña está en segundo plano, y al
    // volver a ella nos quedaríamos con todo parado.
    function enPantalla(tarjeta) {
      var r = tarjeta.getBoundingClientRect();
      var alto = window.innerHeight || document.documentElement.clientHeight;
      var ancho = window.innerWidth || document.documentElement.clientWidth;
      return r.top < alto * 0.9 && r.bottom > alto * 0.1 && r.right > 8 && r.left < ancho - 8;
    }

    function gestionar() {
      var centrada = indiceCentrado();
      var hayVoz = tarjetas.some(function (t) {
        return suena(video(t));
      });

      tarjetas.forEach(function (tarjeta, i) {
        aVista[i] = enPantalla(tarjeta);
      });

      tarjetas.forEach(function (tarjeta, i) {
        var v = video(tarjeta);
        if (!v) return;

        tarjeta.classList.toggle('is-activa', i === centrada && aVista[i]);

        // Un vídeo con sonido manda: no se toca hasta que el cliente decida.
        if (suena(v)) return;

        var debe =
          autoplay && !hayVoz && aVista[i] && (i === centrada || conRaton[i]);

        if (debe && v.paused) {
          reproducir(tarjeta, true);
        } else if (!debe && !v.paused) {
          parar(tarjeta);
        }
      });
    }

    /* ---------- Clic en el vídeo ---------- */

    tarjetas.forEach(function (tarjeta, i) {
      var v = video(tarjeta);
      var boton = tarjeta.querySelector('[data-otx-toque]');
      if (!v || !boton) return;

      boton.addEventListener('click', function () {
        if (v.paused) {
          tarjetas.forEach(function (otra) {
            if (otra !== tarjeta) parar(otra);
          });
          reproducir(tarjeta, false);
        } else if (v.muted) {
          tarjetas.forEach(function (otra) {
            if (otra !== tarjeta) parar(otra);
          });
          v.muted = false;
          pintar(tarjeta);
        } else {
          v.muted = true;
          pintar(tarjeta);
          gestionar();
        }
      });

      ['play', 'pause', 'volumechange', 'ended'].forEach(function (evento) {
        v.addEventListener(evento, function () {
          pintar(tarjeta);
        });
      });

      tarjeta.addEventListener('mouseenter', function () {
        conRaton[i] = true;
        gestionar();
      });

      tarjeta.addEventListener('mouseleave', function () {
        conRaton[i] = false;
        gestionar();
      });

      pintar(tarjeta);
    });

    /* ---------- Qué hay a la vista ---------- */

    var pendiente = false;
    function gestionarPronto() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () {
        pendiente = false;
        gestionar();
      });
    }

    if ('IntersectionObserver' in window) {
      var observador = new IntersectionObserver(gestionarPronto, { threshold: [0, 0.55, 1] });
      tarjetas.forEach(function (tarjeta) {
        observador.observe(tarjeta);
      });
    }

    window.addEventListener('scroll', gestionarPronto, { passive: true });
    window.addEventListener('resize', gestionarPronto);
    gestionar();

    // Al irse de la pestaña se para todo: nadie quiere audio de fondo.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        tarjetas.forEach(parar);
      } else {
        gestionar();
      }
    });

    /* ---------- Navegación ---------- */

    function paso() {
      return tarjetas[0].getBoundingClientRect().width + HUECO;
    }

    function actualizarControles() {
      var i = indiceCentrado();
      var tope = pista.scrollWidth - pista.clientWidth;

      puntos.forEach(function (punto, n) {
        punto.classList.toggle('is-activo', n === i);
        punto.setAttribute('aria-current', n === i ? 'true' : 'false');
      });

      if (prev) prev.disabled = pista.scrollLeft <= 2;
      if (next) next.disabled = pista.scrollLeft >= tope - 2;
    }

    function irA(indice) {
      var tarjeta = tarjetas[Math.max(0, Math.min(tarjetas.length - 1, indice))];
      if (!tarjeta) return;
      pista.scrollTo({
        left: tarjeta.offsetLeft - (pista.clientWidth - tarjeta.offsetWidth) / 2,
        behavior: sinMovimiento ? 'auto' : 'smooth'
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        pista.scrollBy({ left: -paso(), behavior: sinMovimiento ? 'auto' : 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        pista.scrollBy({ left: paso(), behavior: sinMovimiento ? 'auto' : 'smooth' });
      });
    }

    puntos.forEach(function (punto, i) {
      punto.addEventListener('click', function () {
        irA(i);
      });
    });

    var esperando = false;
    pista.addEventListener(
      'scroll',
      function () {
        if (esperando) return;
        esperando = true;
        window.requestAnimationFrame(function () {
          actualizarControles();
          gestionar();
          esperando = false;
        });
      },
      { passive: true }
    );

    // Las medidas cambian con las fuentes, las imágenes y el giro del móvil.
    window.addEventListener('resize', actualizarControles);
    window.addEventListener('load', actualizarControles);
    if ('ResizeObserver' in window) {
      new ResizeObserver(actualizarControles).observe(pista);
    }
    actualizarControles();

    /* ---------- Arrastrar con el ratón ---------- */

    var arrastrando = false;
    var xInicio = 0;
    var scrollInicio = 0;
    var movido = 0;

    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      arrastrando = true;
      movido = 0;
      xInicio = e.clientX;
      scrollInicio = pista.scrollLeft;
      pista.classList.add('is-arrastrando');
    });

    pista.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var delta = e.clientX - xInicio;
      movido = Math.abs(delta);
      if (movido > 4) pista.scrollLeft = scrollInicio - delta;
    });

    function soltar() {
      if (!arrastrando) return;
      arrastrando = false;
      pista.classList.remove('is-arrastrando');
      if (movido > 4) irA(indiceCentrado());
    }

    pista.addEventListener('pointerup', soltar);
    pista.addEventListener('pointerleave', soltar);
    pista.addEventListener('pointercancel', soltar);

    // Un arrastre no debe contar como clic sobre el vídeo.
    pista.addEventListener(
      'click',
      function (e) {
        if (movido > 4) {
          e.preventDefault();
          e.stopPropagation();
          movido = 0;
        }
      },
      true
    );
  }

  function arrancar() {
    document.querySelectorAll('[data-otx-videos]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de temas recarga la sección sin recargar la página.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-otx-videos]').forEach(iniciar);
  });
})();
